<template>
  <AdminLK v-if="isManager && !getFakeUser"/>
  <Applicants v-else-if="(isManager && getFakeUser) || !isExpert"/>
</template>

<script>
import {mapGetters} from "vuex";
import Applicants from "@/2024/components/applicants/Applicants";
import AdminLK from "@/2024/components/applicants/admin/main/AdminLK";

export default {
  name: "ApplicantsView",
  components: {AdminLK, Applicants},
  computed: {
    ...mapGetters('keycloak', {
      getFakeUser: 'getFakeUser',
      isManager: 'isManager',
      isExpert: 'isExpert',
    }),
  },
  created() {
    if (this.isExpert && !this.isManager) {
      this.$router.push({name: 'ApplicantsSelection2024'});
      // this.$router.push({name: 'ApplicantsSelection'});
    }
  }
}
</script>

<style scoped>

</style>